import { useAuth } from '../context/AuthContext';

export function usePermissions() {
    const { user, permissions } = useAuth();

    const isAdmin = !!user?.roles?.some((r: string) => r === 'Admin' /* || r === 'AdminViewer' */);
    const hasPermission = (resource: string, action: 'lecture' | 'modification' | 'suppression' | 'creation') => {
        if (!resource) return false;
        if (isAdmin) return true;
        return !!permissions?.[resource]?.[action];
    };

    return { isAdmin, hasPermission };
}
